<template>
	<div class="integration-details">
		<span class="integration-details__title">Integration Details</span>
		<div class="integration-details__primary">
			<Dropdown
				label="Category Of Service"
				:defaultValue="'Select one'"
				:required="false"
				:options="categoryServiceOptions"
				v-model="value.essentialCategory"
			/>
			<Dropdown
				label="Module Category"
				:options="moduleCategoryOptions"
				v-model="value.moduleCategories"
				:required="true"
				:multiSelect="true"
				:defaultValue="'Select option'"
			/>
		</div>
		<div class="integration-details__secondary">
			<div class="integration-details__group">
				<span class="integration-details__title">Hardware</span>
				<div class="integration-details__radio">
					<span class="integration-details__radio-txt">Is hardware required?</span>
					<RadioButtonGroup
						:items="yesNoOptions"
						v-model="value.isHardwareRequired"
					/>
				</div>
				<Textarea
					label="Hardware Specifications"
					:cols="50"
					:rows="4"
					:maxLength="1500"
					:disabled="!value.isHardwareRequired"
					:required="value.isHardwareRequired"
					v-model="value.hardware"
				/>
			</div>
			<div class="integration-details__group">
				<span class="integration-details__title">Additional Setups</span>
				<div class="integration-details__radio">
					<span class="integration-details__radio-txt"
						>Does the integration have additional setup components? If
						yes, please note any additional steps that maybe required in
						VUE Defaults Settings or by logging into the 3P Vendor
						integration and adjusting settings.</span
					>
					<RadioButtonGroup
						:items="yesNoOptions"
						v-model="value.hasSetupComponent"
					/>
				</div>
				<Textarea
					label="Setup Specifications"
					:cols="50"
					:rows="4"
					:maxLength="1500"
					:disabled="!value.hasSetupComponent"
					:required="value.hasSetupComponent"
					v-model="value.setup"
				/>
			</div>
			<div class="integration-details__group">
				<span class="integration-details__title">Additional Features</span>
				<div class="integration-details__radio">
					<span class="integration-details__radio-txt"
						>Does our end user need to interact with VUE DMS? If yes,
						please note the feature and steps that are needed (For
						example, end user clicks a button in VUE DMS to import
						data).</span
					>
					<RadioButtonGroup
						:items="yesNoOptions"
						v-model="value.isVINSolutionsWizard"
					/>
				</div>
				<Textarea
					label="Feature Specifications"
					:cols="50"
					:rows="4"
					:maxLength="1500"
					:disabled="!value.isVINSolutionsWizard"
					:required="value.isVINSolutionsWizard"
					v-model="value.feature"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import RadioButtonGroup from '@/components/forms/selection-control/radiobutton/radiobutton-group';
import Textarea from '@/components/forms/textarea/textarea.vue';
import {
	moduleCategoriesOpts,
	essentialOpts
} from '@/sections/vendors/integrations/integrationsSettings';

export default {
	name: 'IntegrationDetails',
	components: {
		Dropdown,
		RadioButtonGroup,
		Textarea
	},
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			categoryServiceOptions: essentialOpts,
			moduleCategoryOptions: moduleCategoriesOpts,
			yesNoOptions: [
				{
					labelText: 'Yes',
					disabled: false,
					value: true
				},
				{
					labelText: 'No',
					disabled: false,
					value: false
				}
			]
		};
	},
	created() {
		this.checkRequiredFields();
	},
	methods: {
		requireFieldsAreNotEmpty() {
			const {
				moduleCategories,
				hardware,
				setup,
				feature,
				isHardwareRequired,
				hasSetupComponent,
				isVINSolutionsWizard
			} = this.value;

			if (isHardwareRequired && !hardware) {
				return !!(
					moduleCategories?.length > 0 &&
					hardware
				);
			}
			if (hasSetupComponent && !setup) {
				return !!(
					moduleCategories?.length > 0 &&
					setup
				);
			}
			if (isVINSolutionsWizard && !feature) {
				return !!(
					moduleCategories?.length > 0 &&
					feature
				);
			}
			return !!(moduleCategories?.length > 0);
		},
		checkRequiredFields() {
			if (this.requireFieldsAreNotEmpty()) {
				this.sendResult(true);
			} else {
				this.sendResult(false);
			}
		},
		sendResult(isReadyToSend) {
			this.$emit('input', this.value);

			if (isReadyToSend) {
				this.$emit('valid', true);
				return;
			}
			this.$emit('valid', false);
		}
	},
	watch: {
		value: {
			deep: true,
			handler() {
				this.checkRequiredFields();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.integration-details {
	&__primary {
		width: 526px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: $gutter-xl;
		margin-top: $gutter-lg;
		@include mq($from: md-l) {
			gap: $gutter-xxl
      	}
	}

	&__secondary {
		display: grid;
		grid-template-rows: auto 1fr 1fr;
		gap: $gutter-xl;
		margin-top: $gutter-xxl;
		@include mq($from: md-l) {
			grid-template-columns: repeat(3, 1fr);
			grid-template-rows: 1fr;	
      	}
	}

	&__group {
		display: flex;
		flex-direction: column;
		gap: $gutter-lg;
	}

	&__radio {
		display: flex;
		flex-wrap: wrap;
		gap: $gutter-lg;
		
		&-txt {
			font-size: $label-font-size;
		}
	}

	&__title {
		@include heading(md);
	}
}
</style>
